'use strict';

namespace Core {

    class ModalUspPopupDetails {
        show: boolean;
        public popupContent;
        public header;
        public content;
        public hasSplit = false;

        constructor(
            private $scope: ng.IScope,
            private broker: any,
            )
        {
        }

        init (container : ng.IAugmentedJQuery) {
            this.broker.subscribe('modalUspPopupDetails', 'showModalUspPopupDetails', e => {
                this.show = true;
                this.popupContent = e.data;
                let contentSplit = this.popupContent.split('|');

                this.header = contentSplit[0];
                this.content = contentSplit[1];
            });

            if(TRPCONFIG.IsMobileDevice) {
                (document.querySelector('.great-reasons-banner > div') as HTMLInputElement)
                    .classList.add('isMobile');
            } else {
                (document.querySelector('.great-reasons-banner > div') as HTMLInputElement)
                    .classList.remove('isMobile');
            }

            this.$scope.$on('$destroy', () => {
                this.broker.unsubscribe('modalUspPopupDetails');
            });
        }

    }

    angular
        .module('core')
        .directive('modalUspPopupDetails', (): ng.IDirective => {

            return {
                scope: {},
                controller: ModalUspPopupDetails,
                controllerAs: 'muspd',
                templateUrl: 'partials/home/directivetemplate?type=UspPopupDetails',
                bindToController: {
                    popupContent: '='
                },
                link: function (
                    scope : ng.IScope,
                    el : ng.IAugmentedJQuery,
                    attr,
                    controller : ModalUspPopupDetails) {
                    controller.init(el);
                }
            };
    });

}
